import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardContainerComponent } from '@core/components/dashboard-container/dashboard-container.component';

export const resetPasswordRoutes: Routes = [
  {
    path: ':id',
    component: DashboardContainerComponent,
  },
  {
    path: '',
    component: DashboardContainerComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(resetPasswordRoutes)],
  exports: [RouterModule],
})
export class ResetPasswordRoutingModule {}
